import React from 'react'
import { TrashIcon, ArrowLongUpIcon, ArrowLongDownIcon, PhotoIcon } from '@fourthwall/icons'
import { ModalBox } from '../../../partials/ModalBox'

import * as S from './MobileContextMenu.styled'
import type { IconComponent } from '../../Icon'
import { Icon } from '../../Icon'
import { useModalContext } from '../../../providers/ModalProvider'

interface MobileContextMenuModalProps {
  onView: () => void
  onMoveUp: () => void
  onMoveDown: () => void
  onDelete: () => void
}

const MobileContextMenuModal = ({
  onView,
  onMoveUp,
  onMoveDown,
  onDelete,
}: MobileContextMenuModalProps) => {
  const { close } = useModalContext()

  const handleAction = (action: () => void) => {
    close()
    setTimeout(() => {
      action()
    }, 0)
  }

  return (
    <ModalBox size="small" withoutPadding withoutCloseButton onClose={close}>
      <S.List>
        <ListItem icon={PhotoIcon} label="View full image" onClick={() => handleAction(onView)} />
        <ListItem icon={ArrowLongUpIcon} label="Move up" onClick={() => handleAction(onMoveUp)} />
        <ListItem
          icon={ArrowLongDownIcon}
          label="Move down"
          onClick={() => handleAction(onMoveDown)}
        />
        <ListItem icon={TrashIcon} label="Delete image" onClick={() => handleAction(onDelete)} />
      </S.List>
    </ModalBox>
  )
}

const ListItem = ({
  icon,
  label,
  onClick,
}: {
  icon: IconComponent
  label: string
  onClick: () => void
}) => {
  return (
    <S.Item onClick={onClick} key={label}>
      <Icon component={icon} height={12} width={12} />
      {label}
    </S.Item>
  )
}

export default MobileContextMenuModal
